import branchManagementPhysicalCashCountComponent from './physical_cash_count.component';
import PrintModule from './print';
import './physical_cash_count.scss';

let branchManagementPhysicalCashCountModule = angular.module('branchManagementPhysicalCashCount', [PrintModule])
  .component('branchManagementPhysicalCashCount', branchManagementPhysicalCashCountComponent)
  .name;

export default branchManagementPhysicalCashCountModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/physical_cash_count/index.js